const pageNameKey = "emptyTicketsInboxTicketsPage";

export const emptyTicketsInboxTicketsPageEn = {
  [pageNameKey]: {
    emptyInboxTitle: "Empty Inbox",
    emptyInboxMessage: "There are no tickets in your inbox.",
  },
};

export const emptyTicketsInboxTicketsPagePtBr = {
  [pageNameKey]: {
    emptyInboxTitle: "Caixa de entrada vazia",
    emptyInboxMessage: "Não há tickets na sua caixa de entrada.",
  },
};

export const emptyTicketsInboxTicketsPageDe = {
  [pageNameKey]: {
    emptyInboxTitle: "Leerer Posteingang",
    emptyInboxMessage: "Es befinden sich keine Tickets in Ihrem Posteingang.",
  },
};

export const emptyTicketsInboxTicketsPageZhHans = {
  [pageNameKey]: {
    emptyInboxTitle: "您的收件箱是空的",
    emptyInboxMessage: "您的收件箱中没有票据。",
  },
};

export const emptyTicketsInboxTicketsPageIt = {
  [pageNameKey]: {
    emptyInboxTitle: "La casella di posta in arrivo è vuota",
    emptyInboxMessage: "Non ci sono ticket nella tua casella di posta.",
  },
};

export const emptyTicketsInboxTicketsPageEs = {
  [pageNameKey]: {
    emptyInboxTitle: "Bandeja de entrada vacía",
    emptyInboxMessage: "No hay tickets en tu bandeja de entrada.",
  },
};

export const emptyTicketsInboxTicketsPageNl = {
  [pageNameKey]: {
    emptyInboxMessage: "Er zijn geen tickets in uw Postvak.",
    emptyInboxTitle: "Postvak leeg.",
  },
};

export const emptyTicketsInboxTicketsPageTr = {
  [pageNameKey]: {
    emptyInboxMessage: "Gelen kutunuzda bilet yok.",
    emptyInboxTitle: "Gelen Kutusunu Boşalt",
  },
};
